import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-bottom: 2.5rem;

  .username {
    color: white;
    font-weight: 400;

    @media screen and (max-width: 576px) {
      font-size: 0.8rem;
    }
  }

  .brand {
    @media screen and (max-width: 576px) {
      font-size: 1rem;
    }
  }
`;

export const LogoImg = styled.img`
  width: 32px;
  height: 32px;
  margin: 0px 10px;

  @media screen and (max-width: 576px) {
    width: 28px;
    height: 28px;
  }
`;
